const e = "image", g = {
  "staging-hero": "staging-hero",
  "staging-hero__background": "staging-hero__background",
  "staging-hero__image": "staging-hero__image",
  image: e,
  "staging-hero__wrapper": "staging-hero__wrapper",
  "staging-hero__content": "staging-hero__content",
  "staging-hero__headline": "staging-hero__headline",
  "staging-hero__text": "staging-hero__text",
  "staging-hero__divider": "staging-hero__divider",
  "hero--variant-a": "hero--variant-a",
  "staging-hero__letter": "staging-hero__letter",
  "hero--variant-b": "hero--variant-b"
};
export {
  g as default,
  e as image
};
